/**
 * Generates callback to show popover
 *
 * @param {object} params - Parameters
 * @param {function} params.showRecordPopover - A callback to show popover
 * @param {function} params.recordsShowPopover - A callback to show popover
 * @param {function} params.recordsShowRecord - A callback to show record
 * @param {function} params.onOrderPress - A callback to show order history
 *
 * @returns {function} - Callback - A function to be called when item is pressed
 */

export function generateOnRecordPress({
  showRecordPopover,
  recordsShowPopover,
  recordsShowRecord,
  onOrderPress,
}: any) {
  return ({id}: any) =>
    showRecordPopover([id], {
      recordsShowPopover,
      recordsShowRecord,
      onOrderPress,
    });
}
